<template>
  <Dialog
    width="504px"
    :height="createRenderType == 'pc' ? '' : ''"
    :mobileRenderType="createRenderType == 'pc' ? '' : 'drawerDialog'"
    :customClass="`${createRenderType}-saving-dialog saving-dialog`"
    titleAlign="left"
    :visible="dialogVisible"
    :isOuterHead="true"
    :hideCloseBtn="true"
    @close="onClose"
  >
    <template #outerhead>
      <div class="dialog-title">
        {{ $$t("credit.specilal_yearly") }}
      </div>
    </template>
    <div class="card-box">
      <div class="save-title">{{ $$t("credit.save") }} <span>20%</span></div>
      <div class="desc">{{ $$t("credit.yearly_pro_sub") }}</div>
      <div class="content-box">
        <div class="breakdown">
          <div class="left"></div>
          <div class="center">{{ $$t("credit.your_saving") }}</div>
          <div class="right"></div>
        </div>
        <div class="price mb12">
          <span>{{ $$t("credit.current_monthly_plan") }}</span>
          <span class="white">$30X12=$360/year</span>
        </div>
        <div class="price">
          <span>{{ $$t("credit.yearly_plan_with") }}</span>
          <span class="red">$230.4 / year</span>
        </div>
        <div class="line"></div>
        <div class="price mb20">
          <span>{{ $$t("credit.your_total_savings") }}</span>
          <span class="yellow">$129.6 / year</span>
        </div>
      </div>
      <div class="offer"><i></i>{{ $$t("credit.offer_expires") }}</div>
      <div class="btn-upd">
        <span class="btn-text-green">{{ $t("credit.claim_20_off") }}</span>
      </div>
      <div class="btn-continue">
        <span class="btn-text-high">{{ $$t("credit.maybe_later") }}</span>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { ref, defineProps, onMounted, watch, defineEmits } from "vue";
import { storeToRefs } from "pinia";
import { getProducts } from "@/api/api/apiCredit.js";
import { $$language, $$t } from "@/i18n/i18n.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import moment from "moment";

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const emits = defineEmits(["update:visible", "handleUpgrade"]);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  upgradeDialogData: {
    type: Object,
    default: () => ({}),
  },
});

const dialogVisible = ref(props.visible);
const creditList = ref([]);
const handleLoading = ref(false);

const onClose = () => {
  dialogVisible.value = false;
  emits("update:visible", false);
};

const getList = () => {
  getProducts("stripe", {
    category: "normal",
  }).then((res) => {
    if (res.code == 200) {
      creditList.value = res?.data?.list || [];
    }
  });
};

const handleUpgrade = (product) => {
  handleLoading.value = true;
  emits("handleUpgrade", product);
};

onMounted(() => {
  getList();
});

onUnmounted(() => {
  handleLoading.value = false;
});
</script>

<style lang="scss" scoped>
.saving-dialog {
  .dialog-title {
    color: #fff;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    line-height: normal;
    margin-bottom: 18px;
  }
  .card-box {
    .save-title {
      font-size: 44px;
      font-weight: bold;
      line-height: normal;
      text-align: center;
      color: #fff;
      margin-bottom: 8px;
      span {
        color: #ffe95e;
      }
    }
    .desc {
      padding: 0 32px;
      font-size: 18px;
      font-weight: normal;
      line-height: normal;
      color: #ffffff;
      text-align: center;
      margin-bottom: 20px;
    }
    .content-box {
      background: rgba(0, 0, 0, 0.1);
      padding: 16px 0 8px;
      margin: 0 32px 20px;
      border-radius: 12px;
      color: #fff;
      .breakdown {
        display: flex;
        align-items: center; // 垂直居中
        gap: 8px; // 三个元素之间的间距
        margin-bottom: 20px;
        padding: 0 16px;
        .left{
          flex-grow: 1;
          height: 2px;
          background: linear-gradient(270deg, #FFFFFF -1%, #FFFFFF -1%, rgba(255, 255, 255, 0) 99%);

        }
        .center{
          flex-grow: 0; // center 只根据内容大小伸展
          white-space: nowrap; // 避免换行
          font-size: 18px;
          font-weight: bold;
          line-height: normal;
          
        }
        .right{
          flex-grow: 1;
          height: 2px;
          background: linear-gradient(90deg, #FFFFFF -1%, #FFFFFF -1%, rgba(255, 255, 255, 0) 99%);
          
        }
      }
      .price{
        padding: 0 16px;
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row;
        
        .red{
          color: #FF5F74;
        }
        .yellow{
          color: #FFE95E;
        }
      }
      .mb12{
        margin-bottom: 12px;
      }
      .mb20{
        margin-bottom: 20px;
      }
      .line{
        width: 100%;
        height: 1px;
        background: rgba(148, 173, 255, 0.2);
        margin: 20px 0;
      }
    }
    .btn-upd {
      margin: 0 32px 12px;
      text-align: center;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #000000;
      border-radius: 70px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 16px;
      .btn-text-green {
        font-weight: bold;
        background: linear-gradient(96deg, #a2ff7d 0%, #ffe95e 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
    }
    .btn-continue {
      margin: 0 32px 12px;
      text-align: center;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 70px;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 40px;
      .btn-text-high {
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
      }
    }
    .offer{
      font-size: 14px;
      font-weight: 500;
      line-height: normal;
      display: flex;
      color: #fff;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      i{
        display: block;
        width: 18px;
        height: 18px;
        background-image: url('@/assets/img/credit/ic-clock.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        margin-right: 4px;
      }
    }
  }
  
  &.pc-saving-dialog {
  }
  &.mobile-saving-dialog {
    .dialog-title {
      font-size: 24px;
      font-weight: bold;
      text-align: left;
      padding: 0 20px;
    }
   
    .card-box {
      .save-title{
        text-align: left;
        padding: 0 20px;
      }
      .desc {
        text-align: left;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.4;
        margin: 0 20px 16px;
        position: relative;
        color: rgba(255, 255, 255, 0.8);
        padding: 0;
      }
      .offer{

      }
      
      .content-box {
        margin: 0 20px 20px;
        background: rgba(255, 255, 255, 0.1);
      }
      .btn-upd {
        flex-direction: column;
        background: linear-gradient(101deg, #4fdeff 0%, #e675ff 100%);
        border-radius: 70px;
        color: #000000;
        font-size: 14px;
        font-weight: normal;
        height: 56px;
        .btn-text-green {
          font-size: 16px;
          font-weight: bold;
          color: #000000;
          background: unset;
          -webkit-background-clip: unset;
          -webkit-text-fill-color: unset;
          background-clip: unset;
          text-fill-color: transparent;
        }
      }
      .btn-continue {
        flex-direction: column;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 70px;
        color: rgba(255, 255, 255, 0.5);
        font-size: 12px;
        font-weight: 500;
        margin-bottom: 40px;
        height: 56px;
        .btn-text-high {
          color: #fff;
          font-size: 16px;
          font-weight: 500;
          line-height: normal;
        }
      }
    }
  }
}
</style>
